import React from 'react'
import { Link } from 'react-router-dom';
import { Header, MembersTable } from '../components';
import routes from '../routes/routes';

const users = () => {
    return (
        <div className="mainpanel">

            {/* <!-- pageheader --> */}
            <Header />

            <div className="contentpanel">
                <Link to={routes.public.createUser} type="button" style={{margin: "2rem"}} class="btn btn-primary pull-right">Add Member +</Link>
                <MembersTable />
            </div>

        </div>
    )
}

export default users
